import { Tooltip } from "@/components/ui/tooltip";
import { FuelSlotRequestEntity } from "@/pages/supplies-requests/fuel/schema/fuel-slot-requests.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: FuelSlotRequestEntity;
  handleDetail: (item: FuelSlotRequestEntity) => void;
}

export const FuelSlotRequestActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item)}
          data-testid="fuel-slot-request-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
